<template>
  <!-- 갱신안내 팝업 (수정안 슬라이드 2) — 로그인 후 갱신 대상자에게 노출 -->
  <div id="renewal-notice-popup" class="layer-popup-wrap type-dim">
    <div class="layer-popup">
      <div class="popup-header">
        <h4 class="tit">
          더파르나스<br/>
          갱신 혜택 안내
        </h4>
      </div>
      <div class="popup-body">
        <!--
          줄바꿈 위치가 확정 문구의 일부다("구절 별로 줄바꿈하여 가독성있게").
          화면 폭에 따라 알아서 접히게 두면 문장이 중간에서 끊긴다.
        -->
        <div class="desc-wrap">
          <p>
            회원님의 멤버십이<br/>
            곧 만료될 예정입니다.
          </p>
          <p>
            지금 갱신하시고,<br/>
            레스토랑 이용권 추가 혜택을 받아보세요.
          </p>
        </div>
      </div>
      <div class="btn-wrap full">
        <!-- 퍼블리셔 공통 CSS 의 .btn 은 햄버거 메뉴 버튼이므로 사용하지 않습니다. -->
        <button type="button" class="renewal_popup_btn" @click="goRenewal">
          <span>갱신 혜택 받기</span>
        </button>
        <!-- 다시보지 않기 기간은 파르나스 확정 후 조정 (기획서 5p 코멘트) -->
        <div class="check-list out-check">
          <label for="renewalPopupCheck">
            <input type="checkbox" v-model="checked" id="renewalPopupCheck" class="checkbox-deafult">
            <!-- 공통 CSS 가 실제 체크박스를 숨기고 .checkmark 를 대신 노출합니다. 빠뜨리면 체크박스가 보이지 않습니다. -->
            <span class="checkmark"></span>
            <span class="checkbox-label">{{ hideDays }}일간 보지 않기</span>
          </label>
        </div>
      </div>
      <button class="popup-close" @click="close">
        <span class="hidden">닫기</span>
      </button>
    </div>
  </div>
</template>

<script>
import {NOTICE_HIDE_DAYS} from "@/utils/renewalNotice"

export default {
  name: "RenewalNoticePopup",
  emits: ["close"],
  /*
    확정 문구(수정안 슬라이드 2)에서 회원명·멤버십명·만료일이 모두 빠지면서
    이 팝업은 표시할 데이터가 없어졌다. 그래서 notice prop 을 받지 않는다.
    노출 여부 판단은 그대로 부모(Main.vue)가 한다.
  */
  data() {
    return {
      checked: false,
    }
  },
  computed: {
    /** 문구와 실제 저장 기간이 어긋나지 않도록 상수를 그대로 쓴다. */
    hideDays() {
      return NOTICE_HIDE_DAYS
    },
  },
  methods: {
    /**
     * 갱신 화면으로 이동.
     * 여기서도 체크 상태를 전달한다. 사용자가 "보지 않기"를 체크한 뒤 눌렀다면
     * 그 의사는 유효하므로, 닫기로 나갔을 때와 다르게 취급할 이유가 없다.
     */
    goRenewal() {
      this.$emit("close", this.checked)
      this.$router.push("/renewal-membership")
    },
    close() {
      // 저장은 부모가 한다. 팝업은 회원 식별자를 모르고, 알 필요도 없다.
      this.$emit("close", this.checked)
    },
  },
}
</script>

<style scoped>
#renewal-notice-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9998;
}

#renewal-notice-popup.type-dim {
  background-color: rgba(0, 0, 0, 0.5);
}

.layer-popup {
  /* 더파르나스 브랜드 컬러 = 로고의 PARNAS 글자 색(차콜). 이 팝업은 흰색과 이 색만 쓴다 */
  --brand: #4c4948;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;
  box-sizing: border-box;
  width: 90%;
  max-width: 420px;
  min-height: 400px;
  padding: 40px 20px 28px;
}

.popup-header {
  margin-bottom: 32px;
}

.popup-header .tit {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
}

.popup-body {
  flex-grow: 1;
  margin-bottom: 24px;
}

.popup-body p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #222;
  text-align: center;
}

.popup-body p + p {
  margin-top: 20px;
}

.renewal_popup_btn {
  display: block;
  width: 100%;
  height: 56px;
  border: 0;
  background-color: var(--brand);
  background-image: none;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
}

/* .check-list 는 앱 공통 팝업 스타일을 그대로 사용합니다. (Main.vue 전역 스타일) */

.popup-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.popup-close::before,
.popup-close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 25%;
  width: 50%;
  height: 1px;
  background-color: #222;
}

.popup-close::before {
  transform: rotate(45deg);
}

.popup-close::after {
  transform: rotate(-45deg);
}

.hidden {
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;
  clip: rect(0 0 0 0);
}
</style>
